let cachedCountry: string | null = localStorage.getItem('user_country');

export async function getUserCountry(): Promise<string> {
  if (cachedCountry) return cachedCountry;

  try {
    const res = await fetch('https://ipwho.is');
    const data = await res.json();

    cachedCountry = (data?.country_code || 'US') as string;
    localStorage.setItem('user_country', cachedCountry);
    return cachedCountry;
  } catch (e) {
    console.warn('Country detection failed:', e);
    return 'US';
  }
}
